import { makeStyles } from "@fluentui/react-components";
import { Icon, Stack } from "@fluentui/react";
import React, { useCallback } from "react";
import { useCall } from "@azure/communication-react";
import { Features } from "@azure/communication-calling";
import { PcpPrimaryButton, sidePanePadding, sidePanePaddingNegative } from "live-lesson/shared/feature-call-ui-react";


const useStyles = makeStyles({
    wrapper: {
        zIndex: 10,
        margin: sidePanePaddingNegative,
        padding: sidePanePadding,
        background: '#F9FAFB',
        boxShadow: '0px -2px 10px 0px #00000026',
        justifyContent: "space-around",
    },
});


/**
 * Actions area below the participant list.
 *
 * @constructor
 */
export const CallParticipantListActions = () => {
    const call = useCall();

    const muteAll = useCallback(() => {
        call?.muteAllRemoteParticipants();
    }, [call]);

    const lowerAllHands = useCallback(() => {
        call?.feature(Features.RaiseHand).lowerAllHands();
    }, [call]);

    const styles = useStyles();

    return (
        <Stack horizontalAlign={'center'}  horizontal={true} className={styles.wrapper}>
            <PcpPrimaryButton
                icon={<LowerHandsIcon />}
                onClick={lowerAllHands}
            >
                all hands down
            </PcpPrimaryButton>

            <PcpPrimaryButton
                icon={<MuteAllIcon />}
                onClick={muteAll}
            >
                mute all
            </PcpPrimaryButton>

        </Stack>
    );
};

const MuteAllIcon = (): JSX.Element => <Icon iconName={"ControlButtonMicOff"} />
const LowerHandsIcon = (): JSX.Element => <Icon iconName={"ControlButtonLowerHand"} />
